<template>
  <div id="app">
    <orgHeader />
    <router-view />
    <orgFooter />
  </div>
</template>
<script>
/* eslint-disable no-undef */

import orgHeader from "./components/OrgHeader";
import orgFooter from "./components/OrgFooter";
export default {
  name: "app",
  components: {
    orgHeader,
    orgFooter,
  },
  data() {
    return {
      rota: this.$route.name,
      cidadeCarro: [],
      screenPosition: document.documentElement.scrollTop,
      timeoutId: 0,
    };
  },
  watch: {
    $route(to) {
      this.rota = to.name;
    },
  },
};
</script>
